import chatIcon from "@loot-os/icons/icons/chat";
import { Button } from "../../core/Button.js";
import { useLayout } from "../../foundations/themeContext.js";

export interface ChatLauncherProps {
  /** Its name: "Chat". */
  label: string;
  /** Who's chatting: `count` is shown, `label` is read ("1,284 online"). */
  online?: { count: string; label: string };
  /** The chat is open: the button is pressed. */
  open: boolean;
  onClick: () => void;
  className?: string;
}

/** The nav's way into chat, showing who's online. Closed by default, so the page leads. */
export function ChatLauncher({ label, online, open, onClick, className }: ChatLauncherProps) {
  const layout = useLayout();
  return (
    <Button
      variant={layout.chrome === "glass" ? "glass" : "secondary"}
      size="sm"
      icon={chatIcon}
      aria-expanded={open}
      onClick={onClick}
      className={className}
    >
      <span className="sr-only">{label}</span>
      {online && (
        <span className="flex items-center gap-1.5 font-mono text-mono-meta tabular-nums">
          <span aria-hidden className="size-1.5 rounded-pill bg-status-success" />
          <span aria-hidden>{online.count}</span>
          <span className="sr-only">, {online.label}</span>
        </span>
      )}
    </Button>
  );
}
